import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'sb-internal-server-error-page',
    templateUrl: './internal-server-error-page.component.html',
    styleUrls: ['./internal-server-error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class InternalServerErrorPageComponent implements OnInit {
    constructor(
        private titleService: Title,
        private translateService: TranslateService,
    ) {}

    ngOnInit() {
        this.setTitle(this.translateService.instant('Internal server error'));

        // need to reset min-width: 1000px
        document.body.style.minWidth = 'unset';
    }

    private setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}
